export const RESUME_NODE_WIDTH = 88;

export const START_NODE_WIDTH = 120;
